import React from 'react';
import { Link } from 'react-router-dom';
import cancelIcon from './icons8-cancel.svg';
import { Icon, Label } from 'semantic-ui-react';
import history from '../../../history';
import './sidebar.css';

class SideBar extends React.Component {
  state = { visible: false };
  visible = () => {
    if (this.props.isVisible) {
      return 'visible';
    } else {
      return '';
    }
  };

  handleDropDown = () => {
    this.setState({ visible: !this.state.visible });
  };

  render() {
    const { cart } = this.props;
    return (
      <div
        className={`ui sidebar ${this.visible()} inverted overlay animating right vertical menu`}
      >
        <img
          src={cancelIcon}
          alt="cancel icon"
          onClick={this.props.handleClick}
          className="cancel"
        />
        {this.props.currentUser ? (
          <div className="sidebar-items"> 
            <Link to={{ pathname: "/boatresults", state: { findNearMe: true } }} className="item">
              Boats Near Me
            </Link>
            <Link to={{ pathname: "/boatresults", state: { clearSearch: true } }} className="item" onClick={this.props.handleClick}>
              Rent a Boat
            </Link>
            <Link to="/listaboat" className="item" onClick={this.props.handleClick}>
              List A Boat
            </Link>
            <Link to="/products" className="item" onClick={this.props.handleClick}>
              Marketplace
            </Link>  
            <Link to="/cart" className="item" onClick={this.props.handleClick}>
              <Icon name="shopping cart" />
              Shopping Cart
              {cart?.totalItems > 0 && (
                <Label color="red" style={{ marginLeft: '10px' }}>
                  {cart.totalItems}
                </Label>
              )}
            </Link>                       
            <div
              className="item"
              onClick={() => {
                this.handleDropDown();
              }}
            >
              My Account
              <div
                className={this.state.visible ? 'sub-item-display' : 'sub-item'}
              >
                {this.props.currentUser.roles?.admin === true && (
                  <Link to="/admin" className="item" onClick={this.props.handleClick}>
                    Admin Dashboard
                  </Link>
                )}                
                <Link to="/captain-profile" className="item" onClick={this.props.handleClick}>
                  Dashboard
                </Link>               
                <Link to="/my-favorites" className="item" onClick={this.props.handleClick}>
                  Favorites
                </Link>
                <Link to="/message" className="item" onClick={this.props.handleClick}>
                  Message
                </Link>
                <Link to="/boats" className="item" onClick={this.props.handleClick}>
                  My Boats
                </Link>      
                <Link to="/my-products" className="item" onClick={this.props.handleClick}>
                  My Products
                </Link>
                <Link to="/following" className="item" onClick={this.props.handleClick}>
                  Following
                </Link>                         
                <Link to="/profile/edit" className="item" onClick={this.props.handleClick}>
                  Profile
                </Link>        
                <Link to="/my-purchases" className="item" onClick={this.props.handleClick}>
                  Purchases
                </Link>  
                <Link to="/my-reservations" className="item" onClick={this.props.handleClick}>
                  Reservations
                </Link>                                                            
                <Link to="/settings" className="item" onClick={this.props.handleClick}>
                  Settings
                </Link>             
              </div>
            </div> 
            <Link to="/help" className="item" onClick={this.props.handleClick}>
              How It Works
            </Link>
            <div
              className="item"
              onClick={async () => {
                await this.props.auth.signOut();
                await this.props.handleClick();
                history.push('/');
              }}
            >
              Sign Out
            </div>
          </div>
        ) : (
          <div className="sidebar-items">
            <Link to={{ pathname: "/boatresults", state: { findNearMe: true } }} className="item">
              Boats Near Me
            </Link>
            <Link to={{ pathname: "/boatresults", state: { clearSearch: true } }} className="item" onClick={this.props.handleClick}>
              Rent A Boat
            </Link>
            <Link to="/products" className="item" onClick={this.props.handleClick}>
              Marketplace
            </Link>    
            <Link to="/cart" className="item" onClick={this.props.handleClick}>
              <Icon name="shopping cart" />
              Shopping Cart
              {cart?.totalItems > 0 && (
                <Label color="red" style={{ marginLeft: '10px' }}>
                  {cart.totalItems}
                </Label>
              )}
            </Link>                    
            <Link to="/login" className="item" onClick={this.props.handleClick}>
              Sign In
            </Link>
            <Link to="/signup" className="item" onClick={this.props.handleClick}>
              Sign Up
            </Link>
            <Link to="/help" className="item" onClick={this.props.handleClick}>
              How It Works
            </Link>
          </div>
        )}
      </div>
    );
  }
}

export default SideBar;
